export const questionsData = [
  {
    id: 1,
    name: "InfrastructureAndFacilities",
    title: "البنية التحتية والمرافق",
    titleEn: "Infrastructure and Facilities",
    contents: [
      "المبنى المدرسي محافظ عليه بشكل جيد",
      "فصول دراسية منفصلة لمستويات الصفوف المختلفة",
      "مكتبة تحتوي على مجموعة متنوعة من الكتب والموارد",
      "مختبرات علوم مجهزة بشكل جيد",
      "مختبرات حاسوب للطلاب",
      "غرفة فنية مخصصة",
      "مرافق رياضية مثل ملعب وصالة رياضية",
      "غرفة موسيقى",
      "حمامات نظيفة وقائمة بشكل جيد",
      "كافتيريا أو منطقة توزيع الوجبات",
      "مناطق جلوس خارجية للطلاب",
      "غرفة مخصصة للصلاة أو التأمل",
      "لايوجد",
    ],
    contentsEn: [
      "School edifice is well maintained",
      "Separate classrooms for various academic tiers.",
      "A library that contains various valuable books",
      "Modern laboratories equipped with the latest tools and equipment.",
      "Computer Labs for students",
      "Equipped art room",
      "Numerous sports facilities for students' use",
      "Music Room/Classroom",
      "Well-kept and Clean Bathrooms.",
      "A cafeteria that provides healthy and nutritious food",
      "Outdoor seating areas for students.",
      "Prayer and meditation room.",
      "Not available",
    ],
  },
  {
    id: 2,
    name: "AcademicOffers",
    title: "العروض الأكاديمية",
    titleEn: "Academic Offers",
    contents: [
      "تقديم مجموعة واسعة من المواد",
      "توفر دورات متقدمة (AP)",
      "برنامج التعليم الخاص",
      "أنشطة أكاديمية خارج الدروس مثل نادي النقاش ونادي الرياضيات",
      "نادي الواجبات المنزلية أو دروس مساعدة بعد الدراسة",
      "لايوجد",
    ],
    contentsEn: [
      "Offering a wide range of subjects.",
      "Offering AP (Advanced Placement) programs.",
      "Special Education Program.",
      "Academic activities outside of lessons.",
      "Homework Club or After-School Tutoring Lessons",
      "Not available",
    ],
  },
  {
    id: 3,
    name: "AvailableAcademicSystems",
    title: "الأنظمة الأكاديمية المتاحة",
    titleEn: "Educational systems include",
    contents: [
      "النظام الأمريكي",
      "النظام البريطاني",
      "البكالوريا الدولية (IB)",
      "النظام الفرنسي",
      "النظام الألماني",
      "النظام الكندي",
      "النظام الأسترالي",
      "النظام الصيني",
      "النظام الهندي",
      "النظام السنغافوري",
      "النظام الوطني الأردني",
      "النظام الوطني للإمارات",
      "النظام الوطني للملكة العربية السعودية",
      "لايوجد",
    ],
    contentsEn: [
      "American system",
      "British system",
      "International Baccalaureate (IB)",
      "French system",
      "German system",
      "Canadian system",
      "Australian system",
      "Chinese system",
      "Indian system",
      "Singaporean system",
      "Jordanian national system",
      "The national system of the Emirates",
      "The national system of the Kingdom of Saudi Arabia",
      "Not available",
    ],
  },
  {
    id: 4,
    name: "ClassesOffered",
    title: "الصفوف المقدمة",
    titleEn: "Classes provided",
    contents: [
      "الروضة",
      "المدرسة الابتدائية (الصفوف من 1 إلى 5)",
      "المدرسة المتوسطة (الصفوف من 6 إلى 8)",
      "المدرسة الثانوية (الصفوف من 9 إلى 12",
    ],
    contentsEn: [
      "Kindergarten",
      "Primary school (grades 1 to 5)",
      "Middle School (grades 6 to 8)",
      "High school (grades 9 to 12)",
    ],
  },
  {
    id: 5,
    name: "gender",
    title: "الجنس",
    titleEn: "Gender",
    contents: ["ذكر", "أنثى", "كلاهما"],
    contentsEn: ["Males", "Females", "Both"],
  },
  {
    id: 6,
    name: "EducationalStaff",
    title: "الموظفين التعليميين",
    titleEn: "Educational Staff",
    contents: [
      "معلمين مؤهلين ومعتمدين",
      "نسبة منخفضة بين الطلاب والمعلمين",
      "برامج تطوير مهني للمعلمين",
      "نظام تقييم للمعلمين متاح",
      "لايوجد",
    ],
    contentsEn: [
      "Qualified and Certified Teachers",
      "Low ratio between students and teachers",
      "Standard development programs for teachers",
      "Teacher evaluation system available",
      "Not available",
    ],
  },
  {
    id: 7,
    name: "SupportStudents",
    title: "دعم الطلاب",
    titleEn: "Student Support",
    contents: [
      "مستشار متاح للطلاب",
      "برامج للطلاب ذوي الاحتياجات الخاصة",
      "برنامج التوجيه للطلاب",
      "برنامج دعم الأقران الذي يقوده الطلاب",
      "لايوجد",
    ],
    contentsEn: [
      "Counsellor available for students",
      "Programs for students with special needs",
      "Student Guidance Program",
      "Student-led Peer Support Program",
      "Not available",
    ],
  },
  {
    id: 8,
    name: "HealthAndSafety",
    title: "الصحة والسلامة",
    titleEn: "Health and Safety",
    contents: [
      "غرفة طبية مجهزة باللوازم الأساسية",
      "ممرض بدوام كامل في الطاقم",
      "خطة استجابة للطوارئ موجودة",
      "تدابير السلامة من الحرائق في المدرسة",
      "نظام أمني متاح",
      "لايوجد",
    ],
    contentsEn: [
      "Medical room equipped with essential supplies",
      "Full-time nurse on staff",
      "Emergency response plan in place",
      "Fire safety measures in the school.",
      "Security system available",
      "Not available",
    ],
  },
  {
    id: 9,
    name: "ExtraCurricularActivities",
    title: "الأنشطة اللاصفية",
    titleEn: "Extracurricular activities",
    contents: [
      "فرق رياضية متاحة",
      "أندية فنية وموسيقية متاحة",
      "برنامج دراما أو مسرح",
      "صحيفة طلابية أو نادي صحافة",
      "معارض علوم أو معارض علمية مستضافة",
      "نادي برمجة أو روبوتيات",
      "لايوجد",
    ],
    contentsEn: [
      "Sports teams available",
      "Art and music clubs available",
      "Drama or theatre program",
      "Student newspaper or journalism club",
      "Science fairs or hosted scientific exhibitions",
      "Coding or robotics club",
      "Not available",
    ],
  },
  {
    id: 10,
    name: "CommunityInvolvement",
    title: "مشاركة المجتمع",
    titleEn: "Community engagement",
    contents: [
      "التفاعل مع المجتمع المحلي",
      "المشاركة في مشاريع خدمة المجتمع",
      "تشجيع الآباء على المشاركة",
      "تنظيم فعاليات مفتوحة",
      "لايوجد",
    ],
    contentsEn: [
      "Interaction with the local community",
      "Participation in community service projects",
      "Encouraging parental involvement.",
      "Organizing open events",
      "Not available",
    ],
  },
  {
    id: 11,
    name: "TechnologyAndResources",
    title: "التكنولوجيا والموارد",
    titleEn: "Technology and Resources",
    contents: [
      "وصول إلى الواي فاي للطلاب",
      "لوحات تفاعلية في الفصول الدراسية",
      "توفير أجهزة الكمبيوتر المحمولة أو الأجهزة اللوحية للطلاب",
      "موقع الإنترنت المدرسي للتواصل",
      "الموارد عبر الإنترنت المتاحة للطلاب",
      "لايوجد",
    ],
    contentsEn: [
      "Wi-Fi access for students",
      "Interactive boards in classrooms",
      "Provision of laptops or tablets",
      "Educational website for communication",
      "Online resources available to students",
      "Not available",
    ],
  },
  {
    id: 12,
    name: "Transport",
    title: "النقل",
    titleEn: "Transportation",
    contents: [
      "خدمات الحافلات المدرسية المقدمة من المدرسة",
      "منطقة مخصصة لإنزال واصطفاف الطلاب",
      "تدابير السلامة للنقل",
      "لايوجد",
    ],
    contentsEn: [
      "School bus services provided by the school",
      "Designated area for student drop-off and parking",
      "Safety measures for transportation",
      "Not available",
    ],
  },
  {
    id: 13,
    name: "SpecialPrograms",
    title: "برامج خاصة",
    titleEn: "Special Programs",
    contents: [
      "برنامج للطلاب الموهوبين والمتميزين",
      "برنامج غمرة اللغة",
      "برامج تبادل دولية",
      "برنامج الإرشاد المهني",
      "برنامج الروبوتيات",
      "لايوجد",
    ],
    contentsEn: [
      "Program for gifted and talented students",
      "Language immersion program",
      "nternational exchange programs",
      "Career guidance program",
      "Robotics program",
      "Not available",
    ],
  },
  {
    id: 14,
    name: "ParentParticipation",
    title: "مشاركة الأهل",
    titleEn: "Parental Involvement",
    contents: [
      "اجتماعات منتظمة بين الأهل والمعلمين",
      "جمعية أولياء الأمور المدرسية متاحة",
      "مشاركة الآباء في عمليات اتخاذ القرار",
      "برنامج تثقيف الآباء",
      "لايوجد",
    ],
    contentsEn: [
      "Regular meetings between parents and teachers",
      "School parent association available",
      "Parental participation in decision-making processes",
      "Parent education program",
      "Not available",
    ],
  },
  {
    id: 15,
    name: "StudentConductAndDiscipline",
    title: "سلوك الطلاب والانضباط",
    titleEn: "Student Behaviour and Discipline",
    contents: [
      "ميثاق واضح للسلوك",
      "سياسة مكافحة التنمر موجودة",
      "عقوبات للسلوك التخريبي",
      "برنامج وساطة الأقران",
      "لايوجد",
    ],
    contentsEn: [
      "A clear behaviour charter",
      "Anti-bullying policy in place",
      "Penalties for destructive behaviour",
      "Peer mediation program",
      "Not available",
    ],
  },
  {
    id: 16,
    name: "CareerPreparation",
    title: "الاستعداد للحياة المهنية",
    titleEn: "Career Readiness",
    contents: [
      "خدمات الإرشاد المهني متاحة",
      "تقديم برامج تدريب أو برامج دراسة العمل",
      "تنظيم معارض و وظائف",
      "تركيز على تعليم ريادة الأعمال",
      "لايوجد",
    ],
    contentsEn: [
      "Career counselling services available",
      "Offering training programs or work-study programs",
      "Organizing job fairs and careers events",
      "Focus on entrepreneurship education",
      "Not available",
    ],
  },
  {
    id: 17,
    name: "CommunicationWithParents",
    title: "التواصل مع الأهل",
    titleEn: "Communication with Parents",
    contents: [
      "توفير تحديثات منتظمة للأهل",
      "النشرة المدرسية متاحة",
      "أنظمة الاتصال الآلي مثل البريد الإلكتروني والرسائل القصيرة قيد الاستخدام",
      "بوابة الأهل للوصول عبر الإنترنت",
      "لايوجد",
    ],
    contentsEn: [
      "Providing regular updates to parents",
      "School newsletter available",
      "Use of automated communication systems like email and text messaging",
      "Parent portal for online access",
      "Not available",
    ],
  },
  {
    id: 18,
    name: "other",
    title: "أخرى",
    titleEn: "Other",
    contents: ["التعليم الابتكاري", "تضمين التعلم المستمر"],
    contentsEn: ["Innovative Education", "Include constant learning"],
  },
];
